import { render, staticRenderFns } from "./DetalhesLegislacao.vue?vue&type=template&id=0a978f90&scoped=true"
import script from "./DetalhesLegislacao.vue?vue&type=script&lang=js"
export * from "./DetalhesLegislacao.vue?vue&type=script&lang=js"
import style0 from "./DetalhesLegislacao.vue?vue&type=style&index=0&id=0a978f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a978f90",
  null
  
)

export default component.exports